<template>
  <div class="bank_details">
    <div class="d_top">{{$t('main.text271')}}</div>
    <div class="d_top2">{{$t('main.text272')}}</div>
    <div class="d_box">
        <div class="d_box_top">{{$t('main.text273')}}</div>
        <div class="d_box_body">
            <div class="alert_box">
                <el-alert
                    class="alert_style"
                    type="warning"
                    :closable="false"
                    show-icon>
                    <div slot="title" class="alert_text">
                        {{$t('main.text274')}}
                        <span class="alert_num">{{bank_info.reference}}</span>
                        {{$t('main.text275')}}
                    </div>
                </el-alert>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('main.text276')}}</div>
                    <div class="body_row_t2">{{bank_info.bank_name}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text277')}}</div>
                    <div class="body_row_t2">{{bank_info.bank_address}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text278')}}</div>
                    <div class="body_row_t2">{{bank_info.bank_code}}</div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('main.text279')}}</div>
                    <div class="body_row_t2">{{bank_info.branch_name}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text280')}}</div>
                    <div class="body_row_t2">{{bank_info.bank_acc_number}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text281')}}</div>
                    <div class="body_row_t2">{{bank_info.bank_account_name}}</div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('main.text144')}}</div>
                    <div class="body_row_t2">{{bank_info.country}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text282')}}</div>
                    <div class="body_row_t2">{{bank_info.currency}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text283')}}</div>
                    <div class="body_row_t2">{{bank_info.swift_code}}</div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <!-- <div class="body_row_t1">{{$t('main.text284')}}</div>
                    <div class="body_row_t2">{{bank_info.company_address}}</div> -->
                    <div class="body_row_t1">{{$t('main.text254')}}</div>
                    <div class="body_row_t2">{{bank_info.reference}}</div>
                </div>
                <div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                </div>
                <div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                    <div>
                        <el-button class="body_row_btn border_set_color" @click="Copy()" size="medium">{{$t('main.text285')}}</el-button>
                    </div>
                </div>
                <div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                </div><div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import cryptoJS from 'crypto-js'
// 加密 解密  https://blog.csdn.net/weixin_47424753/article/details/126331686
export default {
    data() {
        return {
            bank_info:{},
            deposit_code:'XXX',
            
        }
    },
    beforeMount() {
        this.$nextTick(()=>{
            this.bus.$on('bank_info_data',(v)=>{
                this.bank_info=v;
                sessionStorage.removeItem('top_title_name',v.currency);
                // console.log(v);
            });
        })
    },
    mounted() {
        let bank_info_data = sessionStorage.getItem("bank_info_data")||'';
        if(bank_info_data){
            this.bank_info = this.info_decode(bank_info_data);
            sessionStorage.setItem('top_title_name',this.$t('main.text687')+this.bank_info.currency);
            // console.log(this.bank_info);
        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    methods: {
        //复制
        copy_api(v) {
            const input = document.createElement("input");
            document.body.appendChild(input);
            input.setAttribute("value", v);
            input.select();
            if (document.execCommand("copy")) {
                document.execCommand("copy");
            }
            document.body.removeChild(input);
            this.message.ismessage('success',this.$t('main.text297'));
            // this.$message.success("复制成功");
        },

        Copy() {
            return new Promise(resolve => {
                //如果复制单行，用input
                //如果复制多行，用textarea
                // this.$t('main.text297')
                // let copy_string=
                // "Name of Bank : "+this.bank_info.bank_name+"\r\n"+
                // "Bank Address : "+this.bank_info.bank_address+"\r\n"+
                // "Bank Code : "+this.bank_info.bank_code+"\r\n"+
                // "Branch Name : "+this.bank_info.branch_name+"\r\n"+
                // "Bank Account Number : "+this.bank_info.bank_acc_number+"\r\n"+
                // "Bank Account Name : "+this.bank_info.bank_account_name+"\r\n"+
                // "Country : "+this.bank_info.country+"\r\n"+
                // "Currency : "+this.bank_info.currency+"\r\n"+
                // "SWIFT Address/Code : "+this.bank_info.swift_code+"\r\n"+
                // "Company Address : "+this.bank_info.company_address+"\r\n"+
                // "Reference : "+this.bank_info.reference;

                let copy_string=
                this.$t('main.text298')+this.bank_info.bank_name+"\r\n"+
                this.$t('main.text299')+this.bank_info.bank_address+"\r\n"+
                this.$t('main.text300')+this.bank_info.bank_code+"\r\n"+
                this.$t('main.text301')+this.bank_info.branch_name+"\r\n"+
                this.$t('main.text302')+this.bank_info.bank_acc_number+"\r\n"+
                this.$t('main.text303')+this.bank_info.bank_account_name+"\r\n"+
                this.$t('main.text304')+this.bank_info.country+"\r\n"+
                this.$t('main.text305')+this.bank_info.currency+"\r\n"+
                this.$t('main.text306')+this.bank_info.swift_code+"\r\n"+
                this.$t('main.text308')+this.bank_info.reference;

                const copyUrl = document.createElement("textarea"); //创建一个textarea框获取需要复制的文本内容
                copyUrl.value = copy_string;
                const appDiv = document.getElementById("app");
                appDiv.appendChild(copyUrl);
                copyUrl.select();
                document.execCommand("Copy");
                copyUrl.remove();
                resolve(true);
                this.message.ismessage('success',this.$t('main.text297'));
            });
        },
        cryptojsDecrypt(word, keyStr, ivStr) {
            let key = cryptoJS.enc.Utf8.parse(keyStr);
            let iv = cryptoJS.enc.Utf8.parse(ivStr);
            // let srcs = cryptoJS.enc.Utf8.parse(word);

            let decrypted = cryptoJS.AES.decrypt(word, key, {
                iv,
                mode: cryptoJS.mode.CBC,
                padding: cryptoJS.pad.Pkcs7
            });
            // return decrypted.toString();
            return cryptoJS.enc.Utf8.stringify(decrypted).toString();
        },
        // cryptojsDecrypt(返回给你的字符串,key, iv);
        info_decode(v){
            let key= "6P7t47zj3dnh5isx";
            let iv= "hrYjdyJ2nBjdKB6G";
            let str1 =  this.cryptojsDecrypt(v,key,iv);
            // console.log(str1);
            return JSON.parse(str1);
        }
    },
}
</script>

<style scoped>
.d_top{
    /* margin-top: 46px; */
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
}
.d_top2{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    opacity: 0.8;
    margin-bottom: 20px;
}
.d_box{
    background: #314B69;
    border-radius: 16px;
    overflow: hidden;
}
.d_box_top{
    box-sizing: border-box;
    padding: 20px 28px;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    border-bottom: 1.5px solid #041E35;
}
.d_box_body{
    box-sizing: border-box;
    padding: 28px;
}
.alert_box{
    min-height: 64px;
}
.body_row{
    display: flex;
    margin-top: 28px;
    justify-content: space-between;
}
.body_row>div{
    width: 31%;
}
.body_row_t1{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.6;
}
.body_row_t2{
    margin-top: 8px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
}
.body_row_btn,
.body_row_btn:hover{
    min-width: 200px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #DEB981;
    background: transparent;
    border-style:solid;
    border-width: 1.5px;
    border-color:#ECBD75 #E3A84E #ECBC74 #F1C788;
}

</style>
